module.exports = __webpack_public_path__ + "img/liuan.cacb8e4f.png";